module.exports = __webpack_public_path__ + "static/media/console-S.inline.7af2215b.svg";